import React, { memo } from 'react';

import { Svg } from '@lglp/components';

function EmailIcon({ className, ...rest }) {
  return (
    <Svg
      className={['email-icon', className]}
      viewBox="0 -256 1850 1850"
      {...rest}
    >
      <path d="M1701.966 1250.678v-768q-32 36-69 66-268 206-426 338-51 43-83 67t-86.5 48.5q-54.5 24.5-102.5 24.5h-2q-48 0-102.5-24.5t-86.5-48.5q-32-24-83-67-158-132-426-338-37-30-69-66v768q0 13 9.5 22.5t22.5 9.5h1472q13 0 22.5-9.5t9.5-22.5zm0-1051v-24.5l-.5-13q-.5-13-3-12.5t-5.5-9q-3-9.5-9-7.5t-14-2.5h-1472q-13 0-22.5 9.5t-9.5 22.5q0 168 147 284 193 152 401 317 6 5 35 29.5t46 37.5q17 13 44.5 31.5t50.5 27.5q23 9 43 9h2q20 0 43-9t50.5-27.5q27.5-18.5 44.5-31.5t46-37.5q29-24.5 35-29.5 208-165 401-317 54-43 100.5-115.5t46.5-131.5zm128-37v1088q0 66-47 113t-113 47h-1472q-66 0-113-47t-47-113v-1088q0-66 47-113t113-47h1472q66 0 113 47t47 113z" />
    </Svg>
  );
}

export default memo(EmailIcon);
